import * as Yup from 'yup';
import logInModel from '../models/logInModel';

const {
  formField: {
    logInEmail,
    logInPass
  }
} = logInModel;

const logInSchema = {
    loggedIn: Yup.boolean(),
    [logInEmail.name]: Yup.string()
      .email(`${logInEmail.invalidErrorMsg}`)
      .when("loggedIn", (loggedIn, schema) => 
        !loggedIn
          ? schema.required(`${logInEmail.requiredErrorMsg}`)
          : schema
      ),
    [logInPass.name]: Yup.string()
      .when("loggedIn", (loggedIn, schema) => 
        !loggedIn
          ? schema.required(`${logInPass.requiredErrorMsg}`).min(8, `${logInPass.invalidErrorMsg}`)
          : schema
      )
};

export default logInSchema
